import template from './report-edit.html';
import './report-edit.styl';

function reportEditComponent($state, $stateParams) {

  'ngInject';

  this.reportId = $stateParams.id;
}

export default {
  template,
  controller: reportEditComponent,
};



// WEBPACK FOOTER //
// ./src/containers/report-edit/index.js